
export function normalizeFilters (filters) {
  let newFilters = {}
  Object.keys(filters).forEach((prop) => {
    if (typeof prop === 'object') {
      return
    }
    if (filters[prop]) //issue trovato , era a null e si spaccava
    { //issue trovato
      newFilters[prop] = filters[prop].value === '' || filters[prop].value === null ? undefined : filters[prop].value
      if(newFilters[prop] === 'object') {
        newFilters[prop] = JSON.parse(JSON.stringify(newFilters[prop]));
      }
      if (filters[prop].replace && newFilters[prop]) {
        newFilters[prop] = filters[prop].replace.replace('VALUE', newFilters[prop])
      }
    } //issue trovato
  })
  return newFilters
}
